module.exports = __webpack_public_path__ + "img/close.f6763ab0.svg";